import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { SportService } from "src/app/sports/sport.service";
import { ReportsService } from "../reports.service";

@Component({
    selector: "app-schedule-sport-overview",
    templateUrl: "./schedule-sport-overview.component.html",
    styleUrls: ["./schedule-sport-overview.component.scss"],
})
export class ScheduleSportOverviewComponent implements OnInit {
    public sportCategory: any = null;
    public sport: any = null;
    public hasTable = true;
    public fixtures: any = null;
    public groups: any = null;
    public resultGroup: any = null;
    public sportId: any = [2, 3, 4, 6, 7, 8, 11, 12, 14];

    constructor(
        private activetedRoute: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private sportService: SportService,
        private reportService: ReportsService
    ) {
        this.spinner.show();

        this.activetedRoute.params.subscribe((params) => {
            if (params === null || params === undefined) {
                setTimeout(() => {
                    this.spinner.hide();
                }, 500);

                return false;
            }
            this.sport = params.name;
            this.getSportCategory(params.id, params.sportId);
        });
    }

    ngOnInit() {}

    getSportCategory(id: number, sportId) {
        this.sportService
            .getSportCategoryDetail(sportId, id)
            .subscribe((res) => {
                this.sportCategory = res;
                this.getFixures(res.id);
            });
    }

    getFixures(id: number) {
        this.reportService.getFixtureByCategory(id).subscribe((res) => {
            if (Object.keys(res.groups).length > 0) {
                this.groups = res.groups;
            }

            if (res.result) {
                this.fixtures = res.result;
            }

            if (Object.keys(res.group_result).length > 0) {
                this.resultGroup = res.group_result;
            }

            setTimeout(() => {
                this.spinner.hide();
            }, 500);
        });
    }

    delete(id: number) {
        if (confirm("ต้องการที่จะลบการแข่งขันใช่ไหม? ")) {
            this.spinner.show();
            this.reportService.delete(id).subscribe((res) => {
                this.spinner.hide();
                // const url = `/report/schedule-sport-overview/${this.paramRedirect.sportId}/${this.paramRedirect.categoryId}/${this.paramRedirect.sportName}`;
                // this.router.navigate([url]);
                this.getFixures(this.sportCategory.id);
            });
        }
    }
}
